// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-closing-main-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100vh;
  background-color: #f9fafc;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1300;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

.session-closing-body-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 100vh;
  overflow-y:auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}

/* Chrome / Safari scrollbar */
.session-closing-body-wrapper::-webkit-scrollbar {
  width: 6px;
}

.session-closing-body-wrapper::-webkit-scrollbar-button {
  display: none;
  height: 0;
  width: 0;
}

.session-closing-body-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.session-closing-body-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.session-closing-body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ── Dark mode ── */
.dark .session-closing-main-container {
  background-color: #0f172a;
  box-shadow: -4px 0 20px rgba(0,0,0,0.4);
}

.dark .session-closing-body-wrapper {
  scrollbar-color: #334155 #0f172a;
}

.dark .session-closing-body-wrapper::-webkit-scrollbar-track {
  background: #0f172a;
}

.dark .session-closing-body-wrapper::-webkit-scrollbar-thumb {
  background: #334155;
}

.dark .session-closing-body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569;
}

`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/SessionClosingDrawerV2/SessionClosingDrawerV2.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".session-closing-main-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 80%;\n  height: 100vh;\n  background-color: #f9fafc;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1300;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out;\n}\n\n.session-closing-body-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  height: 100vh;\n  overflow-y:auto;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 #f1f5f9;\n}\n\n/* Chrome / Safari scrollbar */\n.session-closing-body-wrapper::-webkit-scrollbar {\n  width: 6px;\n}\n\n.session-closing-body-wrapper::-webkit-scrollbar-button {\n  display: none;\n  height: 0;\n  width: 0;\n}\n\n.session-closing-body-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.session-closing-body-wrapper::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.session-closing-body-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* ── Dark mode ── */\n.dark .session-closing-main-container {\n  background-color: #0f172a;\n  box-shadow: -4px 0 20px rgba(0,0,0,0.4);\n}\n\n.dark .session-closing-body-wrapper {\n  scrollbar-color: #334155 #0f172a;\n}\n\n.dark .session-closing-body-wrapper::-webkit-scrollbar-track {\n  background: #0f172a;\n}\n\n.dark .session-closing-body-wrapper::-webkit-scrollbar-thumb {\n  background: #334155;\n}\n\n.dark .session-closing-body-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #475569;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
